import styled from 'styled-components';
import { asRem } from 'utils';
import { breakpoints, colors } from 'Theme';
import { landscapeLeftImage, landscapeRightImage } from 'images/landingpages/cooperation_page';

export default styled.main.attrs({ className: 'landingpage' })`
  overflow-wrap: break-word;
  
  .header-section {
    .container {
      padding: 0 ${asRem(32)};
    }

    &.lg-p-4 .content {
      @media (min-width: ${breakpoints.lg}) {
        padding: 0 ${asRem(68)};
      }
    }
    
    .content {
      max-width: ${asRem(920)};
     

      .mime-elements-headline-1 {
        padding: 0;
        font-family: Poppins-SemiBold;
      }

      .intro {
        padding: 0 0};

        @media (min-width: ${breakpoints.md}) {
          padding: 0 ${asRem(28)};
        }

        @media (min-width: ${breakpoints.lg}) {
          padding: 0 ${asRem(100)};
        }


      }
    }
  
  }

  .image-course-phone {
    position: relative;
    margin-bottom: ${asRem(-210)};
    width: 100%;
    align-self: center;

    @media (min-width: ${breakpoints.md}) {
      position: absolute;
      min-width: ${asRem(180)};
      max-width: ${asRem(340)};
      margin-bottom: 0;
      top: ${asRem(90)};
    }

    @media (min-width: ${breakpoints.lg}) {
      max-width: ${asRem(480)};
      top: ${asRem(80)};
    }
  }

  .image-info-ballooni {
    width: 100%;
  }
  
  &.insuranceCooperationLandingPage {
    section {
      padding: 0;
      
      .container {
        max-width: ${asRem(1008)};
        margin: 0 auto ${asRem(40)};
      }
      
      &.info-section, &.course-section {
        
        padding: ${asRem(64)} ${asRem(20)};
        
        .container {
          margin-bottom: 0;
        }
      }

      &.course-section {
        position: relative;
        
        &:before, &:after {
          z-index: -1;
          bottom: ${asRem(32)};
          background-repeat: no-repeat;
          background-size: contain;
          width: ${asRem(226)};
          height: ${asRem(108)};
          position: absolute;
        }
        
        &.course-count-0, &.course-count-1 {
          &:before, &:after {
            @media (min-width: ${breakpoints.md}) {
              content: '';
            }
          }
        }
        
        &[class*="course-count-"], &[class^="course-count-"] {
          &:before, &:after {
            @media (min-width: ${breakpoints.lg}) {
              content: '';
            }
          }
        }

        &:before {
          background-image: url(${landscapeLeftImage});
          left: 0;
        }

        &:after {
          background-image: url(${landscapeRightImage});
          right: 0;
        }
        
        .course-wrapper {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: ${asRem(16)};
          margin-top: ${asRem(40)};
          
          @media (min-width: ${breakpoints.md}) {
            gap: ${asRem(24)};
          }
          
          @media (min-width: ${breakpoints.lg}) {
            gap: ${asRem(32)};
          }
        }

      }
      
      &.checkmark-section {
        overflow: hidden;
        padding-left: ${asRem(18)};
        padding-right: ${asRem(18)};
        min-height: ${asRem(720)};

       @media (min-width: ${breakpoints.md}) {
         padding-left: ${asRem(20)};
        padding-right: ${asRem(64)};
        }

        @media (min-width: ${breakpoints.lg}) {
          padding: 0;
        }

        .container {
          margin-bottom: 0;
        }
      }
    }
  }

  
  .brands-section {
    z-index: 0;
    display: none;
    
    &.bottom {
      margin: 0;
      padding-top: ${asRem(40)};
      padding-bottom: ${asRem(40)};
    }

    @media (min-width: ${breakpoints.md}) {
      display: block;
      margin: ${asRem(40)} 0;
    }

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .logo-chain {
      margin: 0 auto;
      max-width: ${asRem(630)};
    }
  }

  .insurance-form {
    display: inline-block;
    width: 100%;

    @media (min-width: ${breakpoints.md}) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin: 0 auto ${asRem(48)};
      max-width: ${asRem(780)};
      background-color: ${colors.white.c500};
      color: ${colors.blueGrey.c500};
      border-radius: ${asRem(10)};
      overflow: hidden;
      padding: ${asRem(48)} ${asRem(64)};
      box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: ${breakpoints.md}) {
    .rounded-box {
      padding: 0;
    }
  }

  select#gender {
    margin-bottom: 0 !important;
  }
    
  select.is-invalid {
    border: 2px solid var(--error-c500) !important;
    border-radius: ${asRem(6)};
  }

  .mime-elements-section .image-paragraph-row .mime-elements-paragraph {
    padding: 0 ${asRem(24)};

    @media (min-width: ${breakpoints.md}) {
      padding: 0 ${asRem(160)};
    }

    @media (min-width: ${breakpoints.lg}) {
      padding: 0;
    }
  }
`;
